import React, { useState } from "react";
import { Box, TextField, Button, Typography, Grid, Paper } from "@mui/material";

export default function Contact() {
    const [form, setForm] = useState({
        name: "",
        email: "",
        message: "",
    });

    const contactUsUrl = process.env.REACT_APP_SERVER
        ? `https://salonserver-k8m8.onrender.com/contact_us`
        : `http://localhost:3001/contact_us`;
    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("Form submitted:", form);



        try {
            const response = await fetch(contactUsUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(form),
            });

            const data = await response.json();

            if (data.success) {
                alert("Message sent successfully!");
                setForm({ name: "", email: "", message: "" });
            } else {
                alert("Failed to send. Try again later.");
            }
        } catch (error) {
            console.error("Error sending contact form:", error);
            alert("Something went wrong.");
        }



        alert("Thank you for contacting us!");
    };

    return (
        <Box sx={{ p: { xs: 2, md: 4 }, maxWidth: "800px", margin: "auto" }}>
            <Typography
                variant="h4"
                fontWeight="bold"
                textAlign="center"
                gutterBottom
            >
                Contact Us
            </Typography>



            <Typography
                variant="subtitle1"
                textAlign="center"
                sx={{ mb: 4, color: "gray" }}
            >
                We’d love to hear from you! Send us a message and we’ll respond soon.
            </Typography>

            <Paper elevation={3} sx={{ p: 3, borderRadius: 3 }}>
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Your Name"
                                name="name"
                                value={form.name}
                                onChange={handleChange}
                                fullWidth
                                required
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Your Email"
                                name="email"
                                value={form.email}
                                onChange={handleChange}
                                fullWidth
                                required
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                label="Your Message"
                                name="message"
                                value={form.message}
                                onChange={handleChange}
                                fullWidth
                                required
                                multiline
                                minRows={4}
                            />
                        </Grid>

                        <Grid item xs={12} textAlign="center">
                            <Button
                                type="submit"
                                variant="contained"
                                size="large"
                                sx={{
                                    px: 4,
                                    py: 1,
                                }}
                            >
                                Send Message
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Paper>

            {/* Contact Details at Top */}
            <Box sx={{ textAlign: "center", mb: 3, mt: 5 }}>
                <Typography variant="subtitle1" fontWeight="bold">
                    📍 Address: Groomwell Digital Services, Meghana Kuteer, Malkajgiri, Hyderabad, India
                </Typography>
                <Typography variant="subtitle1" fontWeight="bold">
                    📞 Phone: +91 83338 42398 (WhatsApp )
                </Typography>
                <Typography variant="subtitle1" fontWeight="bold">
                    ✉️ Email: support@groomwell.in
                </Typography>
            </Box>
        </Box>
    );
}
